













































































import UsersList from "@/components/admin/users/UsersListForm.vue";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { UsersList as IUsersList } from "@/api/models/users-list";
import userList, { UsersListParams } from "@/getinfo-api/users";
import { User as IUser } from "@/api/models/user";
import { isRoot } from "@/plugins/roles";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: { CustomButton, UsersList }
})
export default class UsersListView extends Vue {
  @Prop({ default: false }) isAdminFunctional!: boolean;
  usersCount: number | undefined = 0;
  limit: number = 30;
  offset: number = 0;
  users: Array<IUser> = [];
  showSpinner: boolean = false;
  params: UsersListParams = {
    searchField: "",
    snils: "",
    limit: 30,
    offset: 0
  };

  clearFilter() {
    this.params = {
      searchField: "",
      snils: "",
      limit: 30,
      offset: 0
    };
    this.users = [];
    this.getUsers();
  }

  applyFilter() {
    this.params.offset = 0;

    this.users = [];
    this.getUsers();
  }

  get root() {
    return isRoot();
  }

  getUsersByOffset() {
    this.params.offset! += this.params.limit!;
    this.getUsers();
  }

  getUsers() {
    this.showSpinner = true;
    userList(this.params).then((res: { data: IUsersList }) => {
      this.usersCount = res.data.count;
      if (res.data.users) {
        res.data.users.forEach((user: IUser) => {
          this.users.push(user);
        });
      }
      this.showSpinner = false;
    });
  }

  mounted() {
    if (this.root) {
      this.getUsers();
    } else {
      this.$router.push({ name: "error" });
    }
  }
}
